export default __webpack_public_path__ + "static/media/Zahr'sResumeUX-0621.b4f5f7cb.pdf";